export const environment = {
  production: true,
  environment: 'production',
  boUrl: 'https://bo.almundo.com',
};
